export const common = {
  // Page Ressources (bibliothèque d'articles gérée par les chercheurs)
  resources_tab_label: 'Ressources',
  resources_search_placeholder: 'Rechercher une ressource…',
  resources_empty: 'Aucune ressource pour le moment.',
  common_home_title: 'Accueil',
  common_cancel: 'Annuler',
  common_close: 'Fermer',
  common_questionnaire: 'Questionnaire',
  common_clear: 'Effacer',
  common_save: 'Enregistrer',
  common_mail: 'Email',
  common_sms: 'Sms',
  common_copy: 'Copier',
  common_name: 'Prénom',
  common_surname: 'Nom',
  common_lang: 'Langue',
  common_phone: 'Téléphone',
  common_next: 'Suivant',
  common_previous: 'Précédent',
  common_details: 'Détails',
  common_send: 'Envoyer',
  common_start: 'Commencer',
  common_password: 'Mot de passe',
  common_click_to_speak: 'Cliquer pour parler',
  common_server_error_title: "Une erreur de serveur s'est produite",
  common_server_error_desc: "Veuillez réessayer ou contactez-nous",
  common_go_back: "Retour précédent",
  common_nodata_title: "Il n'y a pas de données disponibles",
  common_nodata_desc: "Veuillez réessayer ou contactez-nous",
  common_retry: "Réessayer",
  common_bad_request: "Requete mal formé",
  common_no_slug: "Merci de cliquer sur le lien de l'invitation sur votre boîte email ou messages SMS",
  common_submit: "Envoyer",
  common_sending: "Envoi",
  common_thanks_bug_report: "Merci d’avoir signalé ce bug !",
  common_open: "Ouvrir",
  common_your_email: "Votre email",
  common_bug_description: "Votre message",
  common_all_fields_required: "Veuillez renseigner tous les champs.",
  common_error_occurred: "Une erreur est survenue. Veuillez réessayer.",
  common_attachments: "Pièces jointes",
  common_attachment_add: "Ajouter des fichiers",
  common_attachment_limit: "Maximum {{count}} fichiers",
  common_attachment_size_limit: "Chaque fichier doit être inférieur à {{sizeMb}} Mo",
  common_attachment_type_not_allowed: "Un ou plusieurs fichiers ne sont pas pris en charge",
  common_remove: "Retirer",
  common_dropdown_title: "Veuillez sélectionner :",
  common_dropdown_close_button: "Fermer",
  confirm_quit_study_button: "Quitter Définitivement",
  come_back_later_button: "Je reviendrais plus tard",
  doing_questionnaire_button: "Je fais un questionnaire",
  help_link_part1: "Si tu ne te sens pas bien, tu peux ",
  help_link_part2: "obtenir de l'aide en cliquant ici",
  thank_you: "Merci !",
  you_earned_part1: "Tu as gagné ",
  you_earned_part2: " points !",
  other_questionnaire: "Tu peux encore nous aider en remplissant un autre questionnaire.",
  add_to_home_screen_prompt: "Ajoutez {{appName}} sur votre écran d’accueil.",
  pwa_install_button: "Installer l'application",
  pwa_install_button_aria: "Installer l'application {{appName}}",
  pwa_install_hint: "Ouvrez le menu <kbd>⋮</kbd> puis choisissez <strong>Installer l'application</strong>.",
  pwa_ios_title: "Installer {{appName}}",
  pwa_ios_subtitle: "Ajoutez cette application à votre écran d’accueil",
  pwa_ios_description: "Touchez le bouton Partager, puis sélectionnez « Sur l’écran d’accueil ».",
  pwa_ios_share_step: "1. Appuyez sur le bouton Partager.",
  pwa_ios_add_step: "2. Sélectionnez « Sur l’écran d’accueil ».",
};